"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsAiHubAdminExtraction = void 0;
var react_1 = __importStar(require("react"));
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
var ai_hub_extraction_api_service_1 = __importDefault(require("../shared/services/ai-hub-extraction-api.service"));
require("./styles/ai-hub-extraction.scss");
var formatPercent = function (ratio) { return (ratio * 100).toFixed(1) + "%"; };
var sumByType = function (byType) {
    return Object.keys(byType).map(function (type) {
        var bucket = byType[type];
        return {
            type: type,
            added: bucket.added.length,
            removed: bucket.removed.length,
            changed: bucket.changed.length,
            unchanged: bucket.unchanged,
        };
    });
};
/**
 * DriftSection - on-demand button that triggers the drift monitor and
 * lists the use cases whose latest extraction run differs from the previous
 * one by more than the configured threshold.
 */
var DriftSection = function () {
    var _a = react_1.useState(50), limit = _a[0], setLimit = _a[1];
    var _b = react_1.useState(0.25), threshold = _b[0], setThreshold = _b[1];
    var _c = react_1.useState(null), response = _c[0], setResponse = _c[1];
    var _d = react_1.useState(null), error = _d[0], setError = _d[1];
    var _e = react_1.useState(false), isRunning = _e[0], setIsRunning = _e[1];
    var handleRun = react_1.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var result, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsRunning(true);
                    setError(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, ai_hub_extraction_api_service_1.default.runDriftMonitor({ limit: limit, threshold: threshold })];
                case 2:
                    result = _a.sent();
                    setResponse(result);
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    setError(err_1.message || 'Failed to run drift monitor.');
                    return [3 /*break*/, 5];
                case 4:
                    setIsRunning(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [limit, threshold]);
    return (react_1.default.createElement("section", { className: "ws-ai-hub-extraction__section" },
        react_1.default.createElement("div", { className: "ws-ai-hub-extraction__section-header" },
            react_1.default.createElement("h3", null, "Drift Monitor")),
        react_1.default.createElement("p", { className: "ws-ai-hub-extraction__section-description" }, "Compares each use case\u2019s two most recent successful extraction runs and flags those whose change rate exceeds the threshold. Runs nightly on the server; use this control to trigger an ad-hoc scan."),
        react_1.default.createElement("div", { className: "ws-ai-hub-extraction__form-row" },
            react_1.default.createElement("div", { className: "ws-ai-hub-extraction__field" },
                react_1.default.createElement("label", { htmlFor: "ws-drift-limit" }, "Use case limit"),
                react_1.default.createElement("input", { id: "ws-drift-limit", type: "number", min: 1, max: 500, value: limit, onChange: function (e) { return setLimit(Math.max(1, Number(e.target.value) || 1)); } })),
            react_1.default.createElement("div", { className: "ws-ai-hub-extraction__field" },
                react_1.default.createElement("label", { htmlFor: "ws-drift-threshold" }, "Threshold (0\u20131)"),
                react_1.default.createElement("input", { id: "ws-drift-threshold", type: "number", min: 0.05, max: 1, step: 0.05, value: threshold, onChange: function (e) {
                        var value = Number(e.target.value);
                        if (Number.isFinite(value) && value > 0 && value <= 1) {
                            setThreshold(value);
                        }
                    } })),
            react_1.default.createElement("div", { className: "ws-ai-hub-extraction__actions" },
                react_1.default.createElement(office_ui_fabric_react_1.PrimaryButton, { iconProps: { iconName: 'Play' }, text: isRunning ? 'Running…' : 'Run drift scan', className: "ws-admin-button-filled-primary", onClick: handleRun, disabled: isRunning }))),
        error && react_1.default.createElement("p", { className: "ws-ai-hub-extraction__error" }, error),
        response && (react_1.default.createElement("div", { className: "ws-ai-hub-extraction__results" },
            react_1.default.createElement("div", { className: "ws-ai-hub-extraction__totals" },
                react_1.default.createElement("span", null,
                    "Scanned: ",
                    react_1.default.createElement("strong", null, response.scanned)),
                react_1.default.createElement("span", null,
                    "Flagged: ",
                    react_1.default.createElement("strong", null, response.flagged))),
            response.findings.length === 0 ? (react_1.default.createElement("p", { className: "ws-ai-hub-extraction__section-description" }, "No use cases exceeded the threshold.")) : (react_1.default.createElement("table", { className: "ws-ai-hub-extraction__table" },
                react_1.default.createElement("thead", null,
                    react_1.default.createElement("tr", null,
                        react_1.default.createElement("th", null, "Use case"),
                        react_1.default.createElement("th", null, "From \u2192 to run"),
                        react_1.default.createElement("th", null, "Prompt v"),
                        react_1.default.createElement("th", { className: "numeric" }, "Added"),
                        react_1.default.createElement("th", { className: "numeric" }, "Removed"),
                        react_1.default.createElement("th", { className: "numeric" }, "Changed"),
                        react_1.default.createElement("th", { className: "numeric" }, "Drift"))),
                react_1.default.createElement("tbody", null, response.findings.map(function (finding) {
                    var _a, _b;
                    return (react_1.default.createElement("tr", { key: finding.useCaseId },
                        react_1.default.createElement("td", null, finding.useCaseId),
                        react_1.default.createElement("td", null,
                            finding.fromRunId,
                            " \u2192 ",
                            finding.toRunId),
                        react_1.default.createElement("td", null, (_a = finding.fromPromptVersion) !== null && _a !== void 0 ? _a : '?',
                            " \u2192 ", (_b = finding.toPromptVersion) !== null && _b !== void 0 ? _b : '?'),
                        react_1.default.createElement("td", { className: "numeric" }, finding.added),
                        react_1.default.createElement("td", { className: "numeric" }, finding.removed),
                        react_1.default.createElement("td", { className: "numeric" }, finding.changed),
                        react_1.default.createElement("td", { className: "numeric" }, formatPercent(finding.driftRatio))));
                }))))))));
};
/**
 * RunDiffSection - compare two extraction runs by id (must belong to the
 * same use case). Renders per-element-type counts and totals.
 */
var RunDiffSection = function () {
    var _a = react_1.useState(''), fromId = _a[0], setFromId = _a[1];
    var _b = react_1.useState(''), toId = _b[0], setToId = _b[1];
    var _c = react_1.useState(null), report = _c[0], setReport = _c[1];
    var _d = react_1.useState(null), error = _d[0], setError = _d[1];
    var _e = react_1.useState(false), isRunning = _e[0], setIsRunning = _e[1];
    var handleRun = react_1.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var from, to, result, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    from = Number(fromId);
                    to = Number(toId);
                    if (!Number.isInteger(from) || from <= 0 || !Number.isInteger(to) || to <= 0) {
                        setError('Both run ids must be positive integers.');
                        return [2 /*return*/];
                    }
                    setIsRunning(true);
                    setError(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, ai_hub_extraction_api_service_1.default.diffRuns(from, to)];
                case 2:
                    result = _a.sent();
                    setReport(result);
                    return [3 /*break*/, 5];
                case 3:
                    err_2 = _a.sent();
                    setError(err_2.message || 'Failed to diff runs.');
                    return [3 /*break*/, 5];
                case 4:
                    setIsRunning(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [fromId, toId]);
    return (react_1.default.createElement("section", { className: "ws-ai-hub-extraction__section" },
        react_1.default.createElement("div", { className: "ws-ai-hub-extraction__section-header" },
            react_1.default.createElement("h3", null, "Run Diff")),
        react_1.default.createElement("p", { className: "ws-ai-hub-extraction__section-description" }, "Compare two extraction runs of the same use case. Useful for verifying the impact of a single re-run."),
        react_1.default.createElement("div", { className: "ws-ai-hub-extraction__form-row" },
            react_1.default.createElement("div", { className: "ws-ai-hub-extraction__field" },
                react_1.default.createElement("label", { htmlFor: "ws-rundiff-from" }, "From run id"),
                react_1.default.createElement("input", { id: "ws-rundiff-from", type: "number", value: fromId, onChange: function (e) { return setFromId(e.target.value); } })),
            react_1.default.createElement("div", { className: "ws-ai-hub-extraction__field" },
                react_1.default.createElement("label", { htmlFor: "ws-rundiff-to" }, "To run id"),
                react_1.default.createElement("input", { id: "ws-rundiff-to", type: "number", value: toId, onChange: function (e) { return setToId(e.target.value); } })),
            react_1.default.createElement("div", { className: "ws-ai-hub-extraction__actions" },
                react_1.default.createElement(office_ui_fabric_react_1.PrimaryButton, { iconProps: { iconName: 'BranchCompare' }, text: isRunning ? 'Diffing…' : 'Compare runs', className: "ws-admin-button-filled-primary", onClick: handleRun, disabled: isRunning || !fromId || !toId }))),
        error && react_1.default.createElement("p", { className: "ws-ai-hub-extraction__error" }, error),
        report && (react_1.default.createElement("div", { className: "ws-ai-hub-extraction__results" },
            react_1.default.createElement("div", { className: "ws-ai-hub-extraction__totals" },
                react_1.default.createElement("span", null,
                    "Use case: ",
                    react_1.default.createElement("strong", null, report.useCaseId)),
                react_1.default.createElement("span", null,
                    "Prompt v: ",
                    react_1.default.createElement("strong", null, report.fromPromptVersion),
                    " \u2192",
                    ' ',
                    react_1.default.createElement("strong", null, report.toPromptVersion)),
                react_1.default.createElement("span", null,
                    "Added: ",
                    react_1.default.createElement("strong", null, report.totals.added)),
                react_1.default.createElement("span", null,
                    "Removed: ",
                    react_1.default.createElement("strong", null, report.totals.removed)),
                react_1.default.createElement("span", null,
                    "Changed: ",
                    react_1.default.createElement("strong", null, report.totals.changed)),
                react_1.default.createElement("span", null,
                    "Unchanged: ",
                    react_1.default.createElement("strong", null, report.totals.unchanged))),
            react_1.default.createElement("table", { className: "ws-ai-hub-extraction__table" },
                react_1.default.createElement("thead", null,
                    react_1.default.createElement("tr", null,
                        react_1.default.createElement("th", null, "Element type"),
                        react_1.default.createElement("th", { className: "numeric" }, "Added"),
                        react_1.default.createElement("th", { className: "numeric" }, "Removed"),
                        react_1.default.createElement("th", { className: "numeric" }, "Changed"),
                        react_1.default.createElement("th", { className: "numeric" }, "Unchanged"))),
                react_1.default.createElement("tbody", null, sumByType(report.byType).map(function (row) { return (react_1.default.createElement("tr", { key: row.type },
                    react_1.default.createElement("td", null, row.type),
                    react_1.default.createElement("td", { className: "numeric" }, row.added),
                    react_1.default.createElement("td", { className: "numeric" }, row.removed),
                    react_1.default.createElement("td", { className: "numeric" }, row.changed),
                    react_1.default.createElement("td", { className: "numeric" }, row.unchanged))); })))))));
};
/**
 * PromptDiffSection - compare two prompt versions of an agent across a
 * curated list of use cases. Mirrors the inputs accepted by the CI script.
 */
var PromptDiffSection = function () {
    var _a = react_1.useState('use-case-extractor'), agentName = _a[0], setAgentName = _a[1];
    var _b = react_1.useState(''), fromVersion = _b[0], setFromVersion = _b[1];
    var _c = react_1.useState(''), toVersion = _c[0], setToVersion = _c[1];
    var _d = react_1.useState(''), useCaseIdsRaw = _d[0], setUseCaseIdsRaw = _d[1];
    var _e = react_1.useState(null), response = _e[0], setResponse = _e[1];
    var _f = react_1.useState(null), error = _f[0], setError = _f[1];
    var _g = react_1.useState(false), isRunning = _g[0], setIsRunning = _g[1];
    var handleRun = react_1.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var from, to, useCaseIds, result, err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    from = Number(fromVersion);
                    to = Number(toVersion);
                    useCaseIds = useCaseIdsRaw
                        .split(/[\s,]+/)
                        .map(function (id) { return id.trim(); })
                        .filter(function (id) { return id.length > 0; });
                    if (!agentName.trim()) {
                        setError('Agent name is required.');
                        return [2 /*return*/];
                    }
                    if (!Number.isInteger(from) || from <= 0 || !Number.isInteger(to) || to <= 0) {
                        setError('Prompt versions must be positive integers.');
                        return [2 /*return*/];
                    }
                    if (useCaseIds.length === 0) {
                        setError('At least one use case id is required.');
                        return [2 /*return*/];
                    }
                    if (useCaseIds.length > 50) {
                        setError('Maximum 50 use case ids per request.');
                        return [2 /*return*/];
                    }
                    setIsRunning(true);
                    setError(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, ai_hub_extraction_api_service_1.default.diffPromptVersions({
                            agentName: agentName.trim(),
                            fromVersion: from,
                            toVersion: to,
                            useCaseIds: useCaseIds,
                        })];
                case 2:
                    result = _a.sent();
                    setResponse(result);
                    return [3 /*break*/, 5];
                case 3:
                    err_3 = _a.sent();
                    setError(err_3.message || 'Failed to diff prompt versions.');
                    return [3 /*break*/, 5];
                case 4:
                    setIsRunning(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [agentName, fromVersion, toVersion, useCaseIdsRaw]);
    var renderStatusPill = function (status) {
        if (status === 'ok') {
            return react_1.default.createElement("span", { className: "ws-ai-hub-extraction__pill ws-ai-hub-extraction__pill--ok" }, "ok");
        }
        return (react_1.default.createElement("span", { className: "ws-ai-hub-extraction__pill ws-ai-hub-extraction__pill--warn" }, status));
    };
    return (react_1.default.createElement("section", { className: "ws-ai-hub-extraction__section" },
        react_1.default.createElement("div", { className: "ws-ai-hub-extraction__section-header" },
            react_1.default.createElement("h3", null, "Prompt Version Diff")),
        react_1.default.createElement("p", { className: "ws-ai-hub-extraction__section-description" }, "Compare the latest successful extraction runs of two prompt versions for a curated set of use cases. The same call powers the golden-set CI gate."),
        react_1.default.createElement("div", { className: "ws-ai-hub-extraction__form-row" },
            react_1.default.createElement("div", { className: "ws-ai-hub-extraction__field" },
                react_1.default.createElement("label", { htmlFor: "ws-prompt-agent" }, "Agent name"),
                react_1.default.createElement("input", { id: "ws-prompt-agent", type: "text", value: agentName, onChange: function (e) { return setAgentName(e.target.value); } })),
            react_1.default.createElement("div", { className: "ws-ai-hub-extraction__field" },
                react_1.default.createElement("label", { htmlFor: "ws-prompt-from" }, "From version"),
                react_1.default.createElement("input", { id: "ws-prompt-from", type: "number", min: 1, value: fromVersion, onChange: function (e) { return setFromVersion(e.target.value); } })),
            react_1.default.createElement("div", { className: "ws-ai-hub-extraction__field" },
                react_1.default.createElement("label", { htmlFor: "ws-prompt-to" }, "To version"),
                react_1.default.createElement("input", { id: "ws-prompt-to", type: "number", min: 1, value: toVersion, onChange: function (e) { return setToVersion(e.target.value); } }))),
        react_1.default.createElement("div", { className: "ws-ai-hub-extraction__form-row" },
            react_1.default.createElement("div", { className: "ws-ai-hub-extraction__field" },
                react_1.default.createElement("label", { htmlFor: "ws-prompt-usecases" }, "Use case ids (comma or space separated, max 50)"),
                react_1.default.createElement("textarea", { id: "ws-prompt-usecases", value: useCaseIdsRaw, onChange: function (e) { return setUseCaseIdsRaw(e.target.value); }, placeholder: "uc-001, uc-002, uc-003" })),
            react_1.default.createElement("div", { className: "ws-ai-hub-extraction__actions" },
                react_1.default.createElement(office_ui_fabric_react_1.PrimaryButton, { iconProps: { iconName: 'BranchCompare' }, text: isRunning ? 'Diffing…' : 'Compare prompt versions', className: "ws-admin-button-filled-primary", onClick: handleRun, disabled: isRunning }))),
        error && react_1.default.createElement("p", { className: "ws-ai-hub-extraction__error" }, error),
        response && (react_1.default.createElement("div", { className: "ws-ai-hub-extraction__results" },
            react_1.default.createElement("div", { className: "ws-ai-hub-extraction__totals" },
                react_1.default.createElement("span", null,
                    "Agent: ",
                    react_1.default.createElement("strong", null, response.agentName)),
                react_1.default.createElement("span", null,
                    "Versions: ",
                    react_1.default.createElement("strong", null, response.fromVersion),
                    " \u2192",
                    ' ',
                    react_1.default.createElement("strong", null, response.toVersion)),
                react_1.default.createElement("span", null,
                    "Added: ",
                    react_1.default.createElement("strong", null, response.totals.added)),
                react_1.default.createElement("span", null,
                    "Removed: ",
                    react_1.default.createElement("strong", null, response.totals.removed)),
                react_1.default.createElement("span", null,
                    "Changed: ",
                    react_1.default.createElement("strong", null, response.totals.changed)),
                react_1.default.createElement("span", null,
                    "Unchanged: ",
                    react_1.default.createElement("strong", null, response.totals.unchanged))),
            react_1.default.createElement("table", { className: "ws-ai-hub-extraction__table" },
                react_1.default.createElement("thead", null,
                    react_1.default.createElement("tr", null,
                        react_1.default.createElement("th", null, "Use case"),
                        react_1.default.createElement("th", null, "Status"),
                        react_1.default.createElement("th", null, "From \u2192 to run"),
                        react_1.default.createElement("th", { className: "numeric" }, "Added"),
                        react_1.default.createElement("th", { className: "numeric" }, "Removed"),
                        react_1.default.createElement("th", { className: "numeric" }, "Changed"),
                        react_1.default.createElement("th", { className: "numeric" }, "Unchanged"))),
                react_1.default.createElement("tbody", null, response.useCases.map(function (entry) {
                    var _a, _b, _c, _d, _e, _f, _g, _h;
                    return (react_1.default.createElement("tr", { key: entry.useCaseId },
                        react_1.default.createElement("td", null, entry.useCaseId),
                        react_1.default.createElement("td", null, renderStatusPill(entry.status)),
                        react_1.default.createElement("td", null, entry.diff
                            ? entry.diff.fromRunId + " \u2192 " + entry.diff.toRunId
                            : entry.message || '—'),
                        react_1.default.createElement("td", { className: "numeric" }, (_b = (_a = entry.diff) === null || _a === void 0 ? void 0 : _a.totals.added) !== null && _b !== void 0 ? _b : '—'),
                        react_1.default.createElement("td", { className: "numeric" }, (_d = (_c = entry.diff) === null || _c === void 0 ? void 0 : _c.totals.removed) !== null && _d !== void 0 ? _d : '—'),
                        react_1.default.createElement("td", { className: "numeric" }, (_f = (_e = entry.diff) === null || _e === void 0 ? void 0 : _e.totals.changed) !== null && _f !== void 0 ? _f : '—'),
                        react_1.default.createElement("td", { className: "numeric" }, (_h = (_g = entry.diff) === null || _g === void 0 ? void 0 : _g.totals.unchanged) !== null && _h !== void 0 ? _h : '—')));
                })))))));
};
/**
 * WsAiHubAdminExtraction - admin sub-tab combining the Phase 5 extraction
 * observability tools: drift monitor, run diff, and prompt-version diff.
 */
var WsAiHubAdminExtraction = function () {
    return (react_1.default.createElement("div", { className: "ws-ai-hub-extraction" },
        react_1.default.createElement(DriftSection, null),
        react_1.default.createElement(RunDiffSection, null),
        react_1.default.createElement(PromptDiffSection, null)));
};
exports.WsAiHubAdminExtraction = WsAiHubAdminExtraction;
